import React from "react"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"

export default function RemOrderInput({ values, onChange, disabled }) {
  const { t } = useTranslation()

  return (
    <div className="mb-2">
      <label htmlFor="dt-rem-order" className="block text-sm font-medium text-gray-700 mb-1">
        {t("natura_operations.deposit_transfer.rem_order_number")}
      </label>
      <input
        id="dt-rem-order"
        type="text"
        aria-label="rem_order_number"
        value={values.order_number || ""}
        disabled={disabled}
        onChange={(e) => onChange({ order_number: e.target.value })}
        className="w-full font-mono text-sm border border-gray-300 rounded p-2 disabled:bg-gray-100"
        placeholder="0254402427"
      />
    </div>
  )
}

RemOrderInput.propTypes = {
  values: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
}

RemOrderInput.defaultProps = {
  disabled: false,
}
